import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Link,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  Alert,
  AlertColor,
  AlertTitle,
  CardActions,
} from "@mui/material";
import OrderInterface, {
  WaypointInterface,
} from "../interfaces/OrderInterface";
import moment from "moment";
import {
  DirectionsRenderer,
  GoogleMap,
  Autocomplete,
} from "@react-google-maps/api";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import API_FARE from "../services/apiFare";
import FareInterface from "../interfaces/FareInterface";
import UserBusinessInterface from "../interfaces/UserBusinessInterface";
import AuthService from "../services/auth.service";
import NotyfContext from "../contexts/NotyfContext";
import DeleteIcon from "@mui/icons-material/Delete";
import AppContext from "../contexts/AppContext";
import UserService from "../services/user.service";
import BusinessFareInterface from "../interfaces/BusinessFareInterface";
import BusinessFareEstimateParametersInterface from "../interfaces/BusinessFareEstimateParametersInterface";
import functionsApiPublic from "../services/apiPublic.service";
import { useNavigate } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "400px",
};

function getSteps() {
  return ["Itinerário", "Forma de transporte e entrega"];
}

const CreateOrder = () => {
  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return (
          <>
            <Box
              style={{
                padding: 16,
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={8} md={8} xs={12}>
                  <Grid container spacing={2}>
                    {user?.address?.formatted_address === "" ||
                    user?.address?.formatted_address === undefined ? (
                      <>
                        <Grid item lg={12} md={12} xs={12}>
                          <Alert severity={"info"}>
                            <AlertTitle>Aviso! Perfil incompleto.</AlertTitle>
                            Vá para o perfil e complete o cadastro. Insira o
                            endereço de origem padrão. Em caso de dúvidas,
                            contate o suporte do Leve Aí - Parceiros.
                          </Alert>
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                    <Grid item lg={6} md={6} xs={12}>
                      <ReactGoogleAutocomplete
                        defaultValue={
                          newOrder?.originAddress?.formatted_address
                        }
                        apiKey={`AIzaSyC8DTZMss3oYn-nEBDIBmUshcusQ0NCttY`}
                        onPlaceSelected={(place) => {
                          // console.log(place);
                          if (
                            place !== null &&
                            place !== undefined &&
                            place.formatted_address !== undefined
                          ) {
                            var lat = place?.geometry?.location?.lat(),
                              lng = place?.geometry?.location?.lng();
                            // setOriginTemp(place?.formatted_address);
                            setOrigin(place?.formatted_address);
                            // console.log("ReactGoogleAutocomplete Origin");
                            setNewOrder((prevState) => ({
                              ...prevState,
                              originCoordinate: {
                                type: "Point",
                                coordinates: [lng ?? 0, lat ?? 0],
                              },
                              originAddress: {
                                ...newOrder?.originAddress,
                                formatted_address:
                                  place?.formatted_address ?? "",
                              },
                            }));
                            setBusinessFareEstimateParameters((prevState) => ({
                              ...prevState,
                              start_latitude: lat ?? 0,
                              start_longitude: lng ?? 0,
                              start_address: place?.formatted_address ?? "",
                            }));
                          }
                        }}
                        options={{
                          types: ["geocode", "establishment"],
                          fields: [
                            "formatted_address",
                            "geometry",
                            "geometry.location",
                          ],
                        }}
                        language={"pt-BR"}
                        style={{
                          width: "100%",
                          padding: "16.5px 14px",
                          height: "56px",
                          fontSize: "16px",
                        }}
                      />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                      <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        autoComplete={"off"}
                        value={user?.address?.addressLine2 ?? "-/-"}
                        disabled={false}
                        onChange={(event) => {
                          event.persist();
                          // console.log("Complemento Origem");
                          setNewOrder((prevState) => ({
                            ...prevState,
                            originAddress: {
                              formatted_address:
                                newOrder.originAddress?.formatted_address ??
                                "-/-",
                              addressLine2: event.target.value ?? "-/-",
                              information:
                                newOrder.originAddress?.information ?? "-/-",
                            },
                          }));
                          setBusinessFareEstimateParameters((prevState) => ({
                            ...prevState,
                            start_address:
                              newOrder.originAddress?.formatted_address ??
                              "-/-",
                            start_addressLine2: event.target.value ?? "-/-",
                            start_information:
                              newOrder.originAddress?.information ?? "-/-",
                          }));
                        }}
                        // label={"Complemento"}
                        // placeholder={"Digite o complemento"}
                      />
                    </Grid>

                    <Grid item lg={4} md={4} xs={12}>
                      <TextField
                        fullWidth
                        defaultValue={"-/-"}
                        label="Informação extra"
                        type="text"
                        variant="outlined"
                        placeholder="Digite a informação extra"
                        autoComplete={"off"}
                        onChange={(event) => {
                          event.persist();
                          // console.log("Informação extra Origin");
                          setNewOrder((prevState) => ({
                            ...prevState,
                            originAddress: {
                              formatted_address:
                                newOrder.originAddress?.formatted_address ??
                                "-/-",
                              addressLine2:
                                newOrder.originAddress?.addressLine2 ?? "-/-",
                              information: event.target.value ?? "-/-",
                            },
                          }));
                          setBusinessFareEstimateParameters((prevState) => ({
                            ...prevState,
                            start_address:
                              newOrder.originAddress?.formatted_address ??
                              "-/-",
                            start_addressLine2:
                              newOrder.originAddress?.addressLine2 ?? "-/-",
                            start_information: event.target.value ?? "-/-",
                          }));
                        }}
                      />
                    </Grid>

                    {newOrder.waypoints !== undefined ? (
                      <>
                        {newOrder.waypoints.map((waypoint, index) => (
                          <Grid
                            item
                            lg={12}
                            md={12}
                            xs={12}
                            key={"waypoint-grid-" + index}
                          >
                            <Grid
                              container
                              spacing={2}
                              key={"waypoint-order-" + index}
                            >
                              <Grid item lg={6} md={6} xs={12}>
                                <ReactGoogleAutocomplete
                                  apiKey={`AIzaSyC8DTZMss3oYn-nEBDIBmUshcusQ0NCttY`}
                                  onPlaceSelected={(place) => {
                                    // console.log(place);
                                    if (
                                      place !== null &&
                                      place !== undefined &&
                                      place.formatted_address !== undefined
                                    ) {
                                      var lat =
                                          place?.geometry?.location?.lat(),
                                        lng = place?.geometry?.location?.lng();
                                      let waypoints = newOrder.waypoints;
                                      // waypoints[index].address.formatted_address = place?.formatted_address;
                                      waypoint.address.formatted_address =
                                        place?.formatted_address;
                                      waypoint.coordinate.coordinates = [
                                        lng ?? 0,
                                        lat ?? 0,
                                      ];
                                      // console.log("ReactGoogleAutocomplete Waypoints");
                                      setNewOrder((prevState) => ({
                                        ...prevState,
                                        waypoints: waypoints,
                                      }));
                                      getDirection();
                                    }
                                  }}
                                  options={{
                                    types: ["geocode", "establishment"],
                                    fields: [
                                      "formatted_address",
                                      "geometry",
                                      "geometry.location",
                                    ],
                                  }}
                                  defaultValue={
                                    waypoint.address.formatted_address
                                  }
                                  placeholder={"Digite a parada"}
                                  language={"pt-BR"}
                                  style={{
                                    width: "100%",
                                    padding: "16.5px 14px",
                                    height: "56px",
                                    fontSize: "16px",
                                    borderColor:
                                      waypoint.address.formatted_address ===
                                        "" ||
                                      waypoint.coordinate.coordinates[0] ===
                                        0 ||
                                      waypoint.coordinate.coordinates[1] === 0
                                        ? "red"
                                        : "",
                                  }}
                                />
                              </Grid>
                              <Grid item lg={2} md={2} xs={12}>
                                <TextField
                                  fullWidth
                                  type="text"
                                  variant="outlined"
                                  autoComplete={"off"}
                                  // value={waypoint.address.addressLine2}
                                  disabled={false}
                                  label={"Complemento"}
                                  placeholder={"Digite o complemento"}
                                  onChange={(event) => {
                                    event.persist();
                                    waypoint.address.addressLine2 =
                                      event.target.value;
                                    // console.log("Complemento Origin");
                                    setNewOrder((prevState) => ({
                                      ...prevState,
                                      waypoints: newOrder.waypoints,
                                    }));
                                  }}
                                />
                              </Grid>
                              <Grid item lg={3} md={3} xs={12}>
                                <TextField
                                  fullWidth
                                  defaultValue={"-/-"}
                                  label="Informação extra"
                                  type="text"
                                  variant="outlined"
                                  placeholder="Digite a informação extra"
                                  autoComplete={"off"}
                                  onChange={(event) => {
                                    event.persist();
                                    waypoint.information = event.target.value;
                                    // console.log("Informação extra Waypoints");
                                    setNewOrder((prevState) => ({
                                      ...prevState,
                                      waypoints: newOrder.waypoints,
                                    }));
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                lg={1}
                                md={1}
                                xs={12}
                                style={{
                                  justifyContent: "center",
                                  alignContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <IconButton
                                  aria-label={"delete"}
                                  style={{
                                    alignSelf: "center",
                                  }}
                                  onClick={() => {
                                    let waypoints = newOrder.waypoints;
                                    waypoints?.splice(index, 1);
                                    setNewOrder((prevState) => ({
                                      ...prevState,
                                      waypoints: waypoints,
                                    }));
                                    getDirection();
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}

                    <Grid item lg={12} md={12} xs={12} textAlign={"center"}>
                      <Button
                        style={{
                          margin: "auto",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          let waypoints = newOrder.waypoints;
                          let new_waypoint: WaypointInterface = {
                            address: {
                              formatted_address: "",
                              addressLine2: "",
                            },
                            coordinate: {
                              type: "Point",
                              coordinates: [0, 0],
                            },
                            information: "",
                          };
                          waypoints?.push(new_waypoint);
                          setNewOrder((prevState) => ({
                            ...prevState,
                            waypoints: waypoints,
                          }));
                        }}
                        // disabled={newOrder.waypoints !== undefined && newOrder.waypoints?.length > 2}
                        disabled={true}
                      >
                        Adicionar parada (Em breve)
                      </Button>
                    </Grid>

                    <Grid item lg={6} md={6} xs={12}>
                      <Autocomplete
                        onLoad={onLoadAutocompleteDestination}
                        onPlaceChanged={onPlaceChangedDestination}
                        fields={[
                          "formatted_address",
                          "geometry",
                          "geometry.location",
                        ]}
                      >
                        <TextField
                          fullWidth
                          label="Destino"
                          type="text"
                          variant="outlined"
                          placeholder="Digite o destino"
                          autoComplete={"off"}
                          error={destination === ""}
                          helperText={destination === "" && "Digite o destino"}
                          value={destinationTemp}
                          onChange={(event) => {
                            setDestinationTemp(event.target.value);
                          }}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      </Autocomplete>
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                      <TextField
                        fullWidth
                        defaultValue={"-/-"}
                        label="Complemento"
                        type="text"
                        variant="outlined"
                        placeholder="Digite o complemento"
                        autoComplete={"off"}
                        onChange={(event) => {
                          event.persist();
                          setNewOrder((prevState) => ({
                            ...prevState,
                            toAddress: {
                              formatted_address:
                                newOrder.toAddress?.formatted_address ?? "-/-",
                              addressLine2: event.target.value ?? "-/-",
                              information:
                                newOrder.toAddress?.information ?? "-/-",
                            },
                          }));
                          setBusinessFareEstimateParameters((prevState) => ({
                            ...prevState,
                            end_address:
                              newOrder.toAddress?.formatted_address ?? "-/-",
                            end_addressLine2: event.target.value ?? "-/-",
                            end_information:
                              newOrder.toAddress?.information ?? "-/-",
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}>
                      <TextField
                        fullWidth
                        defaultValue={"-/-"}
                        label="Informação extra"
                        type="text"
                        variant="outlined"
                        placeholder="Digite a informação extra"
                        autoComplete={"off"}
                        onChange={(event) => {
                          event.persist();
                          setNewOrder((prevState) => ({
                            ...prevState,
                            toAddress: {
                              formatted_address:
                                newOrder.toAddress?.formatted_address ?? "-/-",
                              addressLine2:
                                newOrder.toAddress?.addressLine2 ?? "-/-",
                              information: event.target.value ?? "-/-",
                            },
                          }));
                          setBusinessFareEstimateParameters((prevState) => ({
                            ...prevState,
                            end_address:
                              newOrder.toAddress?.formatted_address ?? "-/-",
                            end_addressLine2:
                              newOrder.toAddress?.addressLine2 ?? "-/-",
                            end_information: event.target.value ?? "-/-",
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} xs={12}>
                    <Box mt={4}>
                      <Card>
                        <CardHeader title={"Viabilidade da rota"} />
                        <CardContent>
                          {businessFare === undefined &&
                          businessFareEstimateMessage === "" ? (
                            <>
                              <Typography>
                                Preencha todas as informações e clique em
                                verificar rota.
                              </Typography>
                            </>
                          ) : (
                            <></>
                          )}
                          {businessFare === undefined &&
                          businessFareEstimateMessage !== "" ? (
                            <>
                              <Typography>
                                {businessFareEstimateMessage}
                              </Typography>
                            </>
                          ) : (
                            <></>
                          )}
                          {businessFare !== undefined ? (
                            <>
                              <Typography>
                                Rota ok. Clique em próximo.
                              </Typography>
                            </>
                          ) : (
                            <></>
                          )}
                        </CardContent>
                        <CardActions>
                          <Button
                            variant={"contained"}
                            color={"primary"}
                            onClick={() => {
                              tryToCreateBusinessFare();
                            }}
                            style={{
                              marginRight: 16,
                            }}
                          >
                            Verificar rota
                          </Button>
                        </CardActions>
                      </Card>
                    </Box>
                  </Grid>
                </Grid>

                <Grid item lg={4} md={4} xs={12}>
                  <Box>
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={mapCenter}
                      zoom={12}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                      options={{
                        zoomControlOptions: {
                          position: google.maps.ControlPosition.RIGHT_CENTER,
                        },
                      }}
                    >
                      {directions && (
                        <DirectionsRenderer directions={directions} />
                      )}
                    </GoogleMap>
                  </Box>
                  <Box mt={2} mb={2}>
                    <Typography>
                      Distância entre origem e destino:{" "}
                      {newOrder.distance.toFixed(2)} km
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        );
      case 1:
        return (
          <>
            <Box
              style={{
                padding: 16,
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Nome do destinatário"
                    type="text"
                    variant="outlined"
                    placeholder="Digite o nome do destinatário"
                    autoComplete={"off"}
                    value={newOrder.recipientName}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Destinatário");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        recipientName: event.target.value,
                      }));
                    }}
                    required
                    error={
                      newOrder.recipientName === "" ||
                      newOrder.recipientName === undefined
                    }
                    helperText={
                      newOrder.recipientName === "" ||
                      newOrder.recipientName === undefined
                        ? "Preencha o nome do destinatário."
                        : ""
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Telefone do destinatário"
                    type="text"
                    variant="outlined"
                    placeholder="Digite o nome do destinatário"
                    autoComplete={"off"}
                    value={newOrder.recipientPhone}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Destinatário");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        recipientPhone: event.target.value,
                      }));
                    }}
                    required
                    error={
                      newOrder.recipientPhone === "" ||
                      newOrder.recipientPhone === undefined
                    }
                    helperText={
                      newOrder.recipientPhone === "" ||
                      newOrder.recipientPhone === undefined
                        ? "Preencha o telefone do destinatário."
                        : ""
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="outlined"
                    placeholder="Digite a observação"
                    autoComplete={"off"}
                    value={newOrder.packDescription}
                    onChange={(event) => {
                      event.persist();
                      // console.log("Observações");
                      setNewOrder((prevState) => ({
                        ...prevState,
                        packDescription: event.target.value,
                      }));
                    }}
                  />
                </Grid>

                <Grid item lg={4} md={4} xs={12}>
                  <Card elevation={4}>
                    <Box
                      style={{
                        padding: 16,
                        backgroundColor: "#DDD",
                      }}
                    >
                      <Typography>Pagamento</Typography>
                    </Box>
                    <CardContent>
                      <Box>
                        {businessFare?.vehicleCategories !== undefined && (
                          <Typography>
                            O preço sugerido pelo serviço é de{" "}
                            {Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(
                              businessFare?.vehicleCategories[0]?.sharedPrice ??
                                5
                            )}
                            .
                          </Typography>
                        )}

                        <TextField
                          fullWidth
                          label={"Valor efetivo (R$)*"}
                          variant={"outlined"}
                          defaultValue={
                            businessFare?.vehicleCategories !== undefined
                              ? businessFare?.vehicleCategories[0]?.sharedPrice
                              : 7.25
                          }
                          type={"number"}
                          onChange={(event) => {
                            // console.log(event.target.value);
                            // console.log("Preço custom");
                            setNewOrder((prevState) => ({
                              ...prevState,
                              price: parseFloat(event.target.value) ?? 0.0,
                            }));
                          }}
                          error={newOrder.price < originalPrice}
                          helperText={"Esse é o valor efetivo a ser pago."}
                          style={{
                            marginTop: 16,
                            marginBottom: 16,
                          }}
                          disabled={businessFare !== undefined}
                        />
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Forma de pagamento
                          </FormLabel>
                          <RadioGroup
                            aria-label="Forma de pagamento"
                            name="paymentMethod"
                            value={newOrder.paymentMethod}
                            onChange={(event) => {
                              // console.log("Forma de pagamento");
                              setNewOrder((prevState) => ({
                                ...prevState,
                                paymentMethod: event.target.value,
                              }));
                            }}
                          >
                            <FormControlLabel
                              value={"CASH"}
                              control={<Radio />}
                              label={"Dinheiro"}
                              key={"CASH"}
                              disabled={false}
                            />
                            <FormControlLabel
                              value={"CREDIT"}
                              control={<Radio />}
                              label={"Cartão de crédito - Em breve"}
                              key={"CREDIT"}
                              disabled={true}
                            />
                            <FormControlLabel
                              value={"PREPAID"}
                              control={<Radio />}
                              label={"Saldo pré-pago - Em breve"}
                              key={"PREPAID"}
                              disabled={true}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          </>
        );
      default:
        return "Unknown step";
    }
  }
  const history = useNavigate();
  const notyf = useContext(NotyfContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const appContext = useContext(AppContext);
  const currentUser = AuthService.getCurrentUser();
  const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  });
  const [user, setUser] = useState<UserBusinessInterface>();
  const [directions, setDirections] = useState<google.maps.DirectionsResult>();
  // const [autocompleteOrigin, setAutocompleteOrigin] = useState<google.maps.places.Autocomplete|null>(null);
  const [autocompleteDestination, setAutocompleteDestination] =
    useState<google.maps.places.Autocomplete | null>(null);

  useEffect(() => {
    if (user?.address !== null && user?.address !== undefined) {
      // console.log("Use Effect user?.address");
      setNewOrder((prevState) => ({
        ...prevState,
        originAddress: {
          formatted_address: user.address?.formatted_address ?? "-/-",
          addressLine2: user.address?.addressLine2 ?? "-/-",
        },
        originCoordinate: {
          type: "Point",
          coordinates: [
            user.address?.coordinates[0] ?? 0,
            user.address?.coordinates[1] ?? 0,
          ],
        },
      }));
      setOrigin(user.address.formatted_address ?? "");
      setMapCenter({
        lat: user?.address?.coordinates[1] ?? 0,
        lng: user?.address?.coordinates[0] ?? 0,
      });
      setBusinessFareEstimateParameters((prevState) => ({
        ...prevState,
        start_latitude: user?.address?.coordinates[1] ?? 0,
        start_longitude: user?.address?.coordinates[0] ?? 0,
        start_address: user.address?.formatted_address ?? "-/-",
        start_addressLine2: user.address?.addressLine2 ?? "-/-",
      }));
      // setOriginTemp(user.address.formatted_address ?? "");
    }
  }, [user]);

  useEffect(() => {
    // console.log("useEffect currentUser.id");
    setNewOrder((prevState) => ({ ...prevState, userID: currentUser ?? "" }));
  }, [currentUser]);

  // FARE
  const [fare, setFare] = useState<FareInterface>({
    estimatedPrice: 0,
    estimatedPriceExpress: 0,
    vehicleCategories: [],
  });
  const [businessFare, setBusinessFare] = useState<BusinessFareInterface>();
  const [businessFareEstimateParameters, setBusinessFareEstimateParameters] =
    useState<BusinessFareEstimateParametersInterface>({
      start_latitude: 0,
      start_longitude: 0,
      start_address: "-/-",
      start_addressLine2: "-/-",
      start_information: "-/-",

      end_latitude: 0,
      end_longitude: 0,
      end_address: "-/-",
      end_addressLine2: "-/-",
      end_information: "-/-",
    });
  const [businessFareEstimateMessage, setBusinessFareEstimateMessage] =
    useState<string>("");
  const [triedToCreateBusinessFare, setTriedToCreateBusinessFare] =
    useState<boolean>(false);
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  // const [originTemp, setOriginTemp] = useState<string>("");
  const [destinationTemp, setDestinationTemp] = useState<string>("");
  const [creatingNewOrder, setCreatingNewOrder] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<AlertColor>("info");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [alertMessage, setAlertMessage] = useState<string>("");
  // const [value, setValue] = React.useState<Date | null>(null);
  const [newOrder, setNewOrder] = useState<OrderInterface>({
    // id: "",
    exclusiveDelivery: false,
    convenienceRequired: false,
    vehicleCategory: 2,
    packDescription: "",
    price: 7.6,
    distance: 0,
    originAddress: {
      formatted_address: "",
      addressLine2: "-/-",
      information: "-/-",
    },
    toAddress: {
      formatted_address: "",
      addressLine2: "-/-",
      information: "-/-",
    },
    waypoints: [],
    status: "",
    userID: appContext?.userID ?? "", // PUXAR O ID LOCAL DO USUÁRIO JWT
    userType: "END_USER", //BUSINESS_USER OU END_USER
    originCoordinate: {
      type: "Point",
      coordinates: [0, 0],
    },
    destinationCoordinate: {
      type: "Point",
      coordinates: [0, 0],
    },
    recipientName: "",
    recipientPhone: "",
    deliveryForecastTime: moment().toISOString(),

    // Colunas em exclusão
    packUrgency: false,

    qrCodeReceiverNecessary: false,
    paymentMethod: "CASH",
    paymentOn: "PICKUP",
    scheduleTime: moment().toDate(),
    scheduleCollect: false,
  });

  const [originalPrice, setOriginalPrice] = useState<number>(0);

  const tryToCreateBusinessFare = () => {
    functionsApiPublic
      .createBusinessFare(businessFareEstimateParameters)
      .then((response) => {
        setBusinessFare(response.data);
        setBusinessFareEstimateMessage("");
      })
      .catch((error) => {
        if (error?.response?.data?.message === "AREA_NOT_COVERED_BY_PLATFORM") {
          // setBusinessFareEstimateMessage("Bairro não disponível na plataforma.");
          setBusinessFareEstimateMessage(
            "Bairro fora da área de cobertura inicial da plataforma. Revise antes de prosseguir."
          );
        } else if (
          error?.response?.data?.message === "AREA_NOT_COVERED_BY_BUSINESS"
        ) {
          // setBusinessFareEstimateMessage("Bairro não disponível nesta conta. Habilite no seu perfil.");
          setBusinessFareEstimateMessage(
            "Bairro fora da área de cobertura do seu estabelecimento. Revise antes de prosseguir."
          );
        } else {
          setBusinessFareEstimateMessage("Erro desconhecido. Tente novamente.");
        }
        setBusinessFare(undefined);
      })
      .finally(() => {
        setTriedToCreateBusinessFare(true);
      });
  };

  const tryCreateNewOrder = () => {
    // console.log(newOrder);
    setCreatingNewOrder(true);
    functionsApiPublic
      .createBusinessOrder({
        fareID: businessFare?.fareID ?? undefined,
        recipientName: newOrder.recipientName ?? "-/-",
        vehicleCategory: 2,
        exclusiveDelivery: false,
        convenienceRequired: false,
        paymentMethod: "CASH",
        paymentOn: "PICKUP",
        qrCodeReceiverNecessary: false,
        scheduleCollect: false,
        packDescription: "Pedido do Pede Aí",
        packUrgency: false,
        price: newOrder.price ?? 7.6,
        recipientPhone: newOrder.recipientPhone ?? "-/-",
        confirmationCode: "1234",
        callbackEndpoint: "https://www.google.com",
        distance: newOrder.distance,
        origin: {
          coordinate: {
            coordinates: [
              newOrder.originCoordinate.coordinates[0],
              newOrder.originCoordinate.coordinates[1],
            ],
          },
          formatted_address: newOrder.originAddress?.formatted_address ?? "",
          addressLine2: newOrder.originAddress?.addressLine2 ?? "",
          information: newOrder.originAddress?.information ?? "",
        },
        destination: {
          coordinate: {
            coordinates: [
              newOrder.destinationCoordinate.coordinates[0],
              newOrder.destinationCoordinate.coordinates[1],
            ],
          },
          formatted_address: newOrder.toAddress?.formatted_address ?? "",
          addressLine2: newOrder.toAddress?.addressLine2 ?? "",
          information: newOrder.toAddress?.information ?? "",
        },
      })
      .then((response) => {
        notyf.success("Pedido criado com sucesso!");
        setAlertType("success");
        setAlertTitle("Pedido criado com sucesso!");
        setAlertMessage(
          "Parabéns! Seu pedido foi criado com sucesso pelo Leve Aí - Parceiros. Veja o andamento do pedido no menu."
        );
        setCreatingNewOrder(false);
        history("/orders");
      })
      .catch((error) => {
        // console.log(error);
        if (JSON.stringify(error).includes("401")) {
          AuthService.Logout();
        }

        let alertTitle = "Erro ao criar o pedido!";
        let alertMessage =
          "Um erro ocorreu ao criar o seu pedido. Tente novamente mais tarde. Se o erro persistir, entre em contato com o suporte.";
        // MENSAGENS CUSTOMIZADAS DE ERRO
        if (
          error !== undefined &&
          error?.response !== undefined &&
          error?.response?.data !== undefined
        ) {
          if (error?.response?.data?.type === "INSUFFICIENT_PREPAID_BALANCE") {
            alertMessage =
              "Você não tem saldo suficiente para criar este pedido.";
          }
        }
        // console.log(error);
        notyf.error("Ocorreu um erro ao criar o pedido.");
        setAlertType("error");
        setAlertTitle(alertTitle);
        setAlertMessage(alertMessage);
        setCreatingNewOrder(false);
      });
  };

  const onLoad = React.useCallback(function callback(map) {}, []);

  const onLoadAutocompleteDestination = (
    autocomplete: google.maps.places.Autocomplete
  ) => {
    setAutocompleteDestination(autocomplete);
  };

  const onPlaceChangedDestination = () => {
    // console.log("onPlaceChangedDestination");
    if (
      autocompleteDestination !== null &&
      autocompleteDestination !== undefined
    ) {
      let destination = autocompleteDestination.getPlace();
      if (
        destination !== null &&
        destination !== undefined &&
        destination.formatted_address !== undefined
      ) {
        // console.log(destination);
        var lat = destination?.geometry?.location?.lat(),
          lng = destination?.geometry?.location?.lng();

        setDestinationTemp(destination.formatted_address);
        setDestination(destination.formatted_address);
        // console.log("onPlaceChangedDestination");
        setNewOrder((prevState) => ({
          ...prevState,
          destinationCoordinate: {
            type: "Point",
            coordinates: [lng ?? 0, lat ?? 0],
          },
          toAddress: {
            formatted_address: destination?.formatted_address ?? "-/-",
            addressLine2: newOrder?.toAddress?.addressLine2 ?? "-/-",
          },
        }));
        setBusinessFareEstimateParameters((prevState) => ({
          ...prevState,
          end_latitude: lat ?? 0,
          end_longitude: lng ?? 0,
          end_address: destination?.formatted_address ?? "-/-",
          end_addressLine2: newOrder?.toAddress?.addressLine2 ?? "-/-",
        }));
      }
    } else {
      // console.log('Autocomplete is not loaded yet!')
    }
  };

  const onUnmount = React.useCallback(function callback(map) {}, []);

  const getDirection = useCallback(() => {
    try {
      const directionService = new google.maps.DirectionsService();

      let waypointsAux: { location: google.maps.LatLng }[] = [];
      newOrder.waypoints?.forEach((waypoint, index) => {
        if (
          waypoint.address.formatted_address !== "" &&
          waypoint.coordinate.coordinates[0] !== 0 &&
          waypoint.coordinate.coordinates[1] !== 0
        ) {
          waypointsAux.push({
            location: new google.maps.LatLng(
              waypoint.coordinate.coordinates[1],
              waypoint.coordinate.coordinates[0]
            ),
          });
        }
      });
      directionService.route(
        {
          origin: new google.maps.LatLng({
            lat: newOrder.originCoordinate.coordinates[1],
            lng: newOrder.originCoordinate.coordinates[0],
          }),
          destination: new google.maps.LatLng({
            lat: newOrder.destinationCoordinate.coordinates[1],
            lng: newOrder.destinationCoordinate.coordinates[0],
          }),
          waypoints: waypointsAux,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (
            newOrder.waypoints !== undefined &&
            newOrder?.waypoints?.length > 0
          ) {
            // console.log(response);
            if (status === google.maps.DirectionsStatus.OK) {
              let distance: number = 0;
              if (response !== undefined && response !== null) {
                setDirections(response);
                response?.routes[0].legs.forEach((leg, index) => {
                  if (leg?.distance !== undefined) {
                    distance = distance + (leg?.distance?.value ?? 0);
                    // console.log("add: " + distance);
                  }
                });
                // console.log(distance);
              }
              // console.log("getDirection");
              setNewOrder((prevState) => ({
                ...prevState,
                distance: distance / 1000,
              }));
            }
          } else {
            // console.log(response);
            if (status === google.maps.DirectionsStatus.OK) {
              if (response !== undefined && response !== null) {
                setDirections(response);
              }
              // console.log("getDirection");
              setNewOrder((prevState) => ({
                ...prevState,
                distance:
                  (response?.routes[0].legs[0].distance?.value ?? 1000) /
                    1000 ?? 1,
              }));
            }
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  }, [
    newOrder.destinationCoordinate,
    newOrder.originCoordinate,
    newOrder.waypoints,
  ]);

  useEffect(() => {
    if (
      newOrder.originAddress?.formatted_address !== "" &&
      newOrder.toAddress?.formatted_address !== ""
    ) {
      getDirection();
    }
  }, [
    newOrder.originCoordinate,
    newOrder.destinationCoordinate,
    newOrder.originAddress,
    newOrder.toAddress,
    newOrder.waypoints,
    getDirection,
  ]);

  useEffect(() => {
    const getFareData = () => {
      API_FARE.post("/business-fare", {
        destinationCoordinate: newOrder.destinationCoordinate,
        businessID: newOrder.userID,
      })
        .then((response) => {
          // console.log(response.data);
          setFare(response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTriedToCreateBusinessFare(false);
          setBusinessFare(undefined);
          setBusinessFareEstimateMessage("");
        });
    };

    if (newOrder.distance !== 0) {
      getFareData();
    }
  }, [
    newOrder.distance,
    newOrder.destinationCoordinate,
    newOrder.originCoordinate,
    newOrder.userID,
  ]);

  const fixCategoryPrice = useCallback(() => {
    let tempFare: FareInterface = { vehicleCategories: [] };
    if (fare !== undefined && fare !== null) {
      for (let i = 0; i < fare.vehicleCategories.length; i++) {
        // if ((fare.vehicleCategories[i].maxKM ?? 1) >= newOrder.distance){
        tempFare.vehicleCategories.push(fare.vehicleCategories[i]);
        // }
      }
      if (
        tempFare !== undefined &&
        tempFare.vehicleCategories !== undefined &&
        tempFare.vehicleCategories[0] !== undefined &&
        tempFare.vehicleCategories[0].type !== undefined
      ) {
        setNewOrder((prevState) => ({
          ...prevState,
          vehicleCategory: tempFare.vehicleCategories[0].type ?? 2,
          price:
            (newOrder.exclusiveDelivery
              ? tempFare.vehicleCategories[0].exclusivePrice
              : tempFare.vehicleCategories[0].sharedPrice) ?? 100,
          deliveryForecastTime: newOrder.exclusiveDelivery
            ? tempFare.vehicleCategories[0].exclusiveForecast
            : tempFare.vehicleCategories[0].sharedForecast,
        }));
        setOriginalPrice(
          (newOrder.exclusiveDelivery
            ? tempFare.vehicleCategories[0].exclusivePrice
            : tempFare.vehicleCategories[0].sharedPrice) ?? 100
        );
      }
    }
  }, [fare, newOrder.exclusiveDelivery]);

  useEffect(() => {
    fixCategoryPrice();
  }, [fixCategoryPrice]);

  const waypointInvalid = () => {
    try {
      let isInvalid = false;

      newOrder.waypoints?.forEach((waypoint, index) => {
        if (
          waypoint.coordinate.coordinates[0] === 0 ||
          waypoint.coordinate.coordinates[1] === 0 ||
          waypoint.address.formatted_address === ""
        ) {
          isInvalid = true;
        }
      });

      return isInvalid;
    } catch (error) {
      console.log(error);
      return true;
    }
  };

  useEffect(() => {
    setNewOrder((prevState) => ({
      ...prevState,
      userID: appContext?.userID ?? "",
    }));
  }, [appContext]);

  const getProfileAddress = useCallback(() => {
    UserService.getProfileAddress(currentUser ?? "")
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        if (JSON.stringify(error).includes("401")) {
          AuthService.Logout();
        }

        console.log(error);
      });
  }, [currentUser]);

  useEffect(() => {
    getProfileAddress();
  }, [getProfileAddress]);

  return (
    <>
      <Box m={2}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            Página inicial
          </Link>
          <Link underline="hover" color="inherit" href="/orders">
            Pedidos
          </Link>
          <Typography color="text.primary" aria-current="page">
            Novo pedido
          </Typography>
        </Breadcrumbs>
      </Box>
      <Box
        sx={{
          padding: {
            xs: 0,
            md: "32px",
            lg: "32px",
          },
        }}
      >
        <Box mb={3}>
          <div>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: { optional?: React.ReactNode } = {};
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div>
              {activeStep === steps.length ? (
                <div>
                  {creatingNewOrder ? (
                    <>
                      <Card>
                        <CardHeader title={"Criando novo pedido"} />
                        <CardContent>
                          <CircularProgress />
                        </CardContent>
                      </Card>
                    </>
                  ) : (
                    <>
                      <Card>
                        <CardHeader title={"Criando novo pedido"} />
                        <CardContent>
                          <Alert severity={alertType ?? "info"}>
                            <AlertTitle>{alertTitle}</AlertTitle>
                            {alertMessage}
                          </Alert>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </div>
              ) : (
                <div>
                  <Box>{getStepContent(activeStep)}</Box>

                  <div
                    style={{
                      marginBottom: 124,
                      paddingLeft: 16,
                      paddingRight: 16,
                    }}
                  >
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      style={{
                        display: activeStep === 0 ? "none" : "inline",
                        marginRight: activeStep === 0 ? 0 : 8,
                      }}
                    >
                      Voltar
                    </Button>
                    {activeStep === steps.length - 1 ? (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleNext();
                            tryCreateNewOrder();
                          }}
                          disabled={
                            newOrder.recipientName === "" ||
                            creatingNewOrder ||
                            isNaN(newOrder.price)
                          }
                        >
                          Finalizar
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          disabled={
                            origin === "" ||
                            destination === "" ||
                            newOrder.distance === 0 ||
                            waypointInvalid() ||
                            triedToCreateBusinessFare === false
                          }
                        >
                          Próximo
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default CreateOrder;
